// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app_load_loading {\n  position: fixed !important;\n  left: 282px !important;\n  top: 116px !important;\n  bottom: 22px !important;\n  width: calc(100vw - 304px);\n  border-radius: 6px;\n}\n.mobile_loading .app_load_loading {\n  width: calc(100vw - 44px);\n  left: 22px !important;\n}\n.sidebar_loading .app_load_loading {\n  left: 58px !important;\n  width: calc(100vw - 80px);\n}\n", ""]);
// Exports
module.exports = exports;
